<template>
  <component :is="template"></component>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import {STORE_KEY} from './_store/constants'
  import {STORE_KEY as STORE_KEY_QUESTION} from '@/modules/question/preview-question/_store/constants'
  import store from './_store'
  import storeQuestion from '@/modules/question/preview-question/_store'
  import ViewLibrary from './_views/ViewLibrary'
  import ViewDetailBooks from './_views/ViewDetailBooks'
  import ViewAllBooks from './_views/ViewAllBooks'

  export default {
    name: 'EBookModule',
    props: {
      template: String
    },
    components: {
      ViewLibrary,
      ViewDetailBooks,
      ViewAllBooks,
      DetailLesson: () => import('./_views/DetailLesson.vue'),
      DetailPageLinkLib: () => import('./_views/DetailPageLinkLib.vue'),
      LibraryAll: () => import('./_views/LibraryAll.vue'),
      LibraryAllOfBook: () => import('./_views/LibraryAllOfBook.vue'),
      DetailActiveLearn: () => import('./_views/DetailActiveLearn.vue')
    },
    computed: {
      ...mapState(STORE_KEY, ['paramSearchLessons']),
    },
    created () {
      if (!(STORE_KEY in this.$store._modules.root._children)) {
        this.$store.registerModule(STORE_KEY, store);
      }
    },
    beforeDestroy () {
      this.acResetInitialState(store.initialState)
    },
    methods: {
      ...mapActions(STORE_KEY, ['setParamSearchLesson', 'acSetParamFilterBook', 'acSetParamFilterBookLesson', 'acResetInitialState']),
    }
  }
</script>